
import React, { createContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const RouteContext = createContext();

const useRouterProvider = () => {
  const location = useLocation();
  const history = useHistory();
  const [searchParams, setSearchParams] = useState(null);

  useEffect(() => {
    if (null === searchParams) {
      setSearchParams(newURLSearchParams(location.search));
    }
  }, [location.search, searchParams]);

  const newURLSearchParams = params => new URLSearchParams(params);

  return {
    searchParams,

    getSearch: key => searchParams?.get(key),

    search: (params, pathname) => {
      const newParams = {};
      for (const key of Object.keys(params)) {
        if (params[key] !== null && params[key] !== undefined) {
          newParams[key] = params[key];
        }
      }

      const searchParams$ = newURLSearchParams(newParams);
      history.push({
        pathname: pathname ?? location.pathname,
        search: `?${searchParams$}`,
        state: {  // location state
          update: true,
        },
      });

      setSearchParams(searchParams$);
    },

    push: (...args) => {
      if (typeof args[0] === 'string' && searchParams !== null) {
        args[0] = {
          pathname: args[0],
          search: searchParams.toString()
        }
      }

      history.push.apply(history, args);
    }
  };
};

export default ({ children }) => (
  <RouteContext.Provider value={useRouterProvider()}>
    {children}
  </RouteContext.Provider>
);
